/** Default path for the BCC color logo. */
export const DEFAULT_LOGO_SRC = "/logo/bcc_logo.png";
/** Default path for the BCC white logo (single-line lockup: diamond mark + wordmark).
 *  Stored in the resource bucket like the other logos — resolveStorageUrl prefixes it. */
export const DEFAULT_LOGO_WHITE_SRC = "images/logo/bcc-logo-blanc-ligne.png";
/** BCC diamond icon (the fixed mark, always shown in the header). Stored in the
 *  resource bucket (resolveStorageUrl prefixes it with RESOURCE_BASE_URL). */
export const DEFAULT_LOGO_ICON_SRC = "images/logo/bcc-icon.png";
/** BCC wordmark ("Banque Centrale du Congo" text — shown next to the icon,
 *  responsive: visible on mobile + desktop, hidden on tablet where space is tight). */
export const DEFAULT_LOGO_WORDMARK_SRC = "images/logo/bcc-wordmark-tight.png";
/** Default alt text for the BCC logo. */
export const DEFAULT_LOGO_ALT = "Banque Centrale du Congo";
